"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.animator = void 0;
var animejs_1 = __importDefault(require("animejs"));
var appearTransitions_1 = require("../utils/appearTransitions");
var transitionRemoveCard = function (animator, containerRef) {
    var container = containerRef.current;
    if (container) {
        var animatedElements = container.querySelectorAll([
            '.arwes-card__line',
            '.arwes-card__image',
            '.arwes-card__content-bg'
        ].join(','));
        animejs_1.default.remove(animatedElements);
    }
};
var transitionCard = function (animator, containerRef, theme, bleeps) {
    var _a;
    var flow = animator.flow, duration = animator.duration;
    var isEntering = flow.entering || flow.entered;
    var durationTransition = isEntering ? duration.enter : duration.exit;
    var container = containerRef.current;
    var space = theme.space;
    if (isEntering) {
        (_a = bleeps.object) === null || _a === void 0 ? void 0 : _a.play();
        animejs_1.default({
            targets: container.querySelector('.arwes-card__line-picture'),
            duration: durationTransition,
            easing: 'easeOutSine',
            translateX: [space(4), 0]
        });
        animejs_1.default({
            targets: container.querySelector('.arwes-card__line-content'),
            duration: durationTransition,
            easing: 'easeOutSine',
            translateY: [-space(4), 0]
        });
        appearTransitions_1.transitionAppear({
            targets: container.querySelectorAll('.arwes-card__line'),
            duration: durationTransition
        });
        appearTransitions_1.transitionAppear({
            targets: container.querySelectorAll('.arwes-card__image, .arwes-card__content-bg'),
            duration: durationTransition,
            delay: durationTransition
        });
    }
    else {
        appearTransitions_1.transitionDisappear({
            targets: container.querySelectorAll([
                '.arwes-card__line',
                '.arwes-card__image',
                '.arwes-card__content-bg'
            ].join(',')),
            duration: durationTransition
        });
    }
};
var animator = {
    manager: 'stagger',
    onAnimateEntering: transitionCard,
    onAnimateExiting: transitionCard,
    onAnimateUnmount: transitionRemoveCard
};
exports.animator = animator;
